/* eslint-disable no-param-reassign */
import Fetch, { V1 } from 'Util/fetcher';

//= ========================================================================================//
//                                          GET GLOSSARY LIST                               //
//= ========================================================================================//

const ON_REQUEST_GLOSSARY = 'ON_REQUEST_GLOSSARY';
const ON_REQUEST_GLOSSARY_SUCCESS = 'ON_REQUEST_GLOSSARY_SUCCESS';
const ON_REQUEST_GLOSSARY_FAILURE = 'ON_REQUEST_GLOSSARY_FAILURE';

function onRequestGlossary(resetData) {
  return {
    type: ON_REQUEST_GLOSSARY,
    meta: { resetData },
  };
}

function onRequestGlossarySuccess(payload) {
  return {
    type: ON_REQUEST_GLOSSARY_SUCCESS,
    payload,
  };
}

function onRequestGlossaryFailure(payload) {
  return {
    type: ON_REQUEST_GLOSSARY_FAILURE,
    payload,
  };
}

export const onDoRequestGlossary = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestGlossary(resetData));
  Fetch.get(`${V1}common/glossaries/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestGlossarySuccess(resp.json));
      } else {
        dispatch(onRequestGlossaryFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestGlossaryFailure(error.message));
    });
};
const INITIAL_STATE = {
  glossaryLoading: null,
  glossaryData: null,
  glossaryError: null,
};

const glossary = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_REQUEST_GLOSSARY:
      if (action.meta.resetData) {
        return {
          ...state,
          glossaryLoading: true,
          glossaryData: null,
          glossaryError: null,
        };
      } 
        return {
          ...state,
          glossaryLoading: true,
          glossaryError: null,
        };
      
    case ON_REQUEST_GLOSSARY_SUCCESS:
      if (state.glossaryData) {
        const oldResults = [...state.glossaryData.results];
        state.glossaryData = {
          next: action.payload.next,
          results: [...oldResults, ...action.payload.results],
        };
      } else {
        state.glossaryData = action.payload;
      }
      return {
        ...state,
        glossaryLoading: false,
        glossaryError: null,
      };
    case ON_REQUEST_GLOSSARY_FAILURE:
      return {
        ...state,
        glossaryLoading: false,
        glossaryError: action.payload,
      };

    default:
      return state;
  }
};

export default glossary;
